import React, { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import ClientSlide from './ClientSlide';

// Fisher–Yates shuffle
function shuffleArray(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}

function ClientSlider(props) {
    const shuffledSlides = useMemo(() => {
        return shuffleArray(props.slides);
    }, [props.slides]);

    return (
        <div className="client-slider overflow-hidden">
            <div className="row">
                <div className="col-lg-12">
                    <Swiper
                        modules={[Autoplay]}
                        slidesPerView={4}
                        grabCursor={true}
                        autoplay={{ delay: 5000 }}
                        loop={false}
                        speed={2500}
                        breakpoints={{
                            0: { slidesPerView: 2 },
                            768: { slidesPerView: 4 },
                        }}
                    >
                        {shuffledSlides.map((slide, index) => (
                            <SwiperSlide className="client-slide" key={index}>
                                <ClientSlide image={slide.image} url={slide.url} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default ClientSlider;
